import type { ProfileConfig } from "@worker/config-schema";
import { el } from "../../lib/dom";
import { widgetShell, fetchWidget } from "./base";

type AnilistWidget = Extract<ProfileConfig["widgets"][number], { type: "anilist" }>;

type AnilistData = {
  user: string;
  mode: string;
  entries: {
    title: string;
    progress: number;
    total: number | null;
    cover?: string;
    score: number;
  }[];
};

export function mountAnilistWidget(cfg: AnilistWidget): HTMLElement {
  const label = cfg.mode === "current-manga" ? "Manga" : "Anime";
  const shell = widgetShell({ kind: "anilist", title: `AniList · ${label}`, accent: "#02a9ff" });
  shell.setLoading();

  const controller = new AbortController();
  shell.root.addEventListener("bio:teardown", () => controller.abort());

  const render = async () => {
    const env = await fetchWidget<AnilistData>(
      "anilist",
      { u: cfg.username, mode: cfg.mode },
      { signal: controller.signal },
    );
    if (!env.ok || !env.data) return shell.setError(env.error ?? "unavailable");
    const d = env.data;
    if (d.entries.length === 0) return shell.setError("nothing in progress");
    shell.body.innerHTML = "";
    const list = el("ul", { class: "widget-anilist__list" });
    for (const entry of d.entries) {
      const item = el("li", { class: "widget-anilist__item" });
      if (entry.cover) {
        item.append(el("img", { class: "widget-anilist__cover", src: entry.cover, alt: "", draggable: false }));
      }
      const info = el("div", { class: "widget-anilist__info" });
      info.append(el("div", { class: "widget-anilist__title" }, [entry.title]));
      info.append(
        el("div", { class: "widget-anilist__progress" }, [
          `${entry.progress}${entry.total ? ` / ${entry.total}` : ""}`,
        ]),
      );
      item.append(info);
      list.append(item);
    }
    shell.body.append(list);
  };

  void render();
  const interval = window.setInterval(render, 5 * 60_000);
  shell.root.addEventListener("bio:teardown", () => window.clearInterval(interval));

  return shell.root;
}
